import React, { useEffect, useState } from "react"
import { Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import {
  EMPLOYMENT_TYPE_MULTI,
  EMPLOYMENT_RESIGN_STATUS,
  FILTER_CONDITION_ID_NAME,
  FILTER_CONDITION_TAG_TYPE_STATUS,
  FILTER_CONDITION_YEAR,
  FILTER_OBJECTS,
  FILTER_VALUES,
} from "src/modules/const"
import { Filter } from "./Filter"
import SelectField from "src/components/atom/SelectField"
import InputTextField from "src/components/atom/InputTextField"
import MultiSelectField from "src/components/atom/MultiSelectField"
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined"
import "./employee_table.scss"
import { SelectDataType } from "src/components/atom/SelectDataType"
import { Tag } from "src/openapi"

interface Props {
  filter: Filter
  setObject: any
  setCondition: any
  setRange: any
  setValues: any
  handleDelete: any
  tags: Tag[]
  index?: number
}
export const FilterRecord = ({
  filter,
  setObject,
  setCondition,
  setRange,
  setValues,
  handleDelete,
  tags,
  index,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "employee" })

  const [tagValues, setTagValues] = useState<number[]>([])
  const [typeValues, setTypeValues] = useState<number[]>([0])
  const [statusValue, setStatusValue] = useState<string>("none")

  const tagSelectFields: SelectDataType[] = tags.map((tag) => {
    return {
      value: tag.id,
      label: tag.tag,
    }
  })

  const handleSetObject = (o: string) => {
    setObject(index, o)

    if (o == FILTER_VALUES.NAME || o == FILTER_VALUES.ID) {
      handleSetCondition(FILTER_VALUES.CONTAIN)
      handleSetRange("")
    } else if (o == FILTER_VALUES.YEAR) {
      handleSetCondition(FILTER_VALUES.LARGER)
      handleSetRange("")
    } else if (o == FILTER_VALUES.TAG) {
      handleSetCondition(FILTER_VALUES.SAME)
      handleSetValues([])
    } else if (o == FILTER_VALUES.TYPE) {
      handleSetCondition(FILTER_VALUES.SAME)
      handleSetRange([0])
    } else if (o == FILTER_VALUES.STATUS) {
      handleSetCondition(FILTER_VALUES.SAME)
      handleSetRange("none")
    }
  }

  const handleSetCondition = (c: string) => {
    setCondition(index, c)
  }

  const handleSetRange = (r: any) => {
    if (
      filter.object == FILTER_VALUES.ID ||
      filter.object == FILTER_VALUES.NAME ||
      filter.object == FILTER_VALUES.YEAR
    ) {
      setRange(index, r)
    } else if (filter.object == FILTER_VALUES.TYPE) {
      setRange(index, r.slice(1, r.length).join(","))
      setTypeValues(r)
    } else if (filter.object == FILTER_VALUES.STATUS) {
      setRange(index, r)
      setStatusValue(r)
    }
  }

  const handleSetValues = (r: any) => {
    if (filter.object == FILTER_VALUES.TAG) {
      setValues(
        index!,
        r.map((v: string) => Number(v))
      )
      setTagValues(r)
    }
  }

  const getArr = (arrayString: string) => {
    let arr: any[] = [0]
    if (arrayString != "") {
      let res_tags = arrayString.split(",")
      res_tags?.forEach((t) => {
        arr.push(t)
      })
    }
    return arr
  }

  useEffect(() => {
    if (filter) {
      if (filter.object == FILTER_VALUES.TYPE) {
        if (filter.range != "") setTypeValues(getArr(filter.range))
      } else if (filter.object == FILTER_VALUES.STATUS) {
        setStatusValue(filter.range)
      }
    }
  }, [filter])

  return (
    <Box sx={{ display: "flex" }}>
      <SelectField
        selected={filter.object}
        handleSelected={handleSetObject}
        datas={FILTER_OBJECTS}
        inputStyle={{ width: "300px", height: "44px", fontSize: "15px" }}
        sx={{ mb: "10px" }}
        placeholder={t("filter_object")}
      />
      {filter.object == FILTER_VALUES.NAME || filter.object == FILTER_VALUES.ID ? (
        <SelectField
          selected={filter.condition}
          handleSelected={handleSetCondition}
          datas={FILTER_CONDITION_ID_NAME}
          inputStyle={{ width: "300px", height: "44px", fontSize: "15px" }}
          sx={{ mb: "10px" }}
          placeholder={t("filter_object")}
        />
      ) : filter.object == FILTER_VALUES.YEAR ? (
        <SelectField
          selected={filter.condition}
          handleSelected={handleSetCondition}
          datas={FILTER_CONDITION_YEAR}
          inputStyle={{ width: "300px", height: "44px", fontSize: "15px" }}
          sx={{ mb: "10px" }}
          placeholder={t("filter_object")}
        />
      ) : filter.object == FILTER_VALUES.TAG ||
        filter.object == FILTER_VALUES.TYPE ||
        filter.object == FILTER_VALUES.STATUS ? (
        <SelectField
          selected={filter.condition}
          handleSelected={handleSetCondition}
          datas={FILTER_CONDITION_TAG_TYPE_STATUS}
          inputStyle={{ width: "300px", height: "44px", fontSize: "15px" }}
          sx={{ mb: "10px" }}
          placeholder={t("filter_object")}
        />
      ) : (
        <SelectField
          selected={filter.condition}
          handleSelected={handleSetCondition}
          datas={FILTER_CONDITION_ID_NAME}
          inputStyle={{ width: "300px", height: "44px", fontSize: "15px" }}
          sx={{ mb: "10px" }}
          placeholder={t("filter_object")}
        />
      )}
      {filter.object == FILTER_VALUES.NAME ||
      filter.object == FILTER_VALUES.ID ||
      filter.object == FILTER_VALUES.YEAR ? (
        <InputTextField
          text={filter.range}
          handleText={handleSetRange}
          inputStyle={{ width: "300px", height: "44px", fontSize: "15px" }}
          placeholder={t("filter_range_condition")}
        />
      ) : filter.object == FILTER_VALUES.TAG ? (
        <MultiSelectField
          sx={{ width: "300px", height: filter.range == "" ? "44px" : "auto", mb: "10px" }}
          inputStyle={{
            width: "300px",
            height: filter.range == "" ? "44px" : "fit-to-content",
            fontSize: "15px",
          }}
          datas={tagSelectFields}
          selected={tagValues}
          handleSelected={handleSetValues}
          placeholder={t("please_select")}
          padding="10.5px !important"
        ></MultiSelectField>
      ) : filter.object == FILTER_VALUES.TYPE ? (
        <MultiSelectField
          sx={{ width: "300px", height: filter.range == "" ? "44px" : "auto", mb: "10px" }}
          inputStyle={{
            width: "300px",
            height: filter.range == "" ? "44px" : "fit-to-content",
            fontSize: "15px",
          }}
          datas={EMPLOYMENT_TYPE_MULTI}
          selected={typeValues}
          handleSelected={handleSetRange}
          placeholder={t("please_select")}
          padding="10.5px !important"
        ></MultiSelectField>
      ) : (
        <SelectField
          sx={{ width: "300px", height: filter.range == "" ? "44px" : "auto", mb: "10px" }}
          selected={statusValue}
          handleSelected={handleSetRange}
          datas={EMPLOYMENT_RESIGN_STATUS}
          inputStyle={{ width: "300px", height: "44px", fontSize: "15px" }}
          placeholder={t("please_select")}
        />
      )}
      <Box
        sx={{
          mx: "8px",
          mt: "10px",
          cursor: "pointer",
          opacity: "0.3",
          ":hover": { opacity: "1" },
        }}
        onClick={() => {
          {
            handleDelete(index)
          }
        }}
      >
        <HighlightOffOutlinedIcon />
      </Box>
    </Box>
  )
}
